module.exports = __webpack_public_path__ + "static/media/icon-consulting.54bc71e3.svg";